"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UserItemStyled = require("./UserItem-styled.js");
var _UserIcon = _interopRequireDefault(require("calcite-ui-icons-react/UserIcon"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UserItem = function UserItem(_ref) {
  var _ref$item = _ref.item,
    title = _ref$item.title,
    alias = _ref$item.alias,
    state = _ref$item.state,
    primary = _ref.primary,
    onClick = _ref.onClick;
  var active = state === _stateTypes.default.USER_ITEM_ACTIVE;
  var disabled = state === _stateTypes.default.USER_ITEM_DISABLED;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_UserItemStyled.StyledUserItem, {
    active: active,
    disabled: disabled,
    leftNode: primary ? /*#__PURE__*/_react.default.createElement(_UserIcon.default, {
      color: "#000",
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_UserIcon.default, {
      size: 16
    }),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_UserItemStyled.StyledListItemTitle, {
    active: active
  }, "".concat(alias, " (").concat(title, ")"))));
};
var _default = UserItem;
exports.default = _default;